export const computedFontSize = (text:string | undefined,baseFontSize:number, maxWidth:number) => {
    // text文本内容, baseFontSize基准字体大小, maxWidth外部容器宽度
    //if(!props.active)return 2
    if (text == undefined){
        return 2
    }
    const textWidth = text.length;
    let fontSize = baseFontSize;
    if (textWidth > maxWidth) {
        fontSize = baseFontSize * ((maxWidth*0.9 / textWidth));
    }
    return fontSize;
};
export const paddingSize = (size:number)=>{
    let base = 1;
    //if(!props.active)return 1
    if(size<2){
        base = 3.5-size;
    }
    // console.log(window.innerWidth)
    // console.log("size",size)
    // console.log("padding_top",base)
    // console.log("total",size+base)

    return base;

}
